module.exports = __webpack_public_path__ + "static/img/mo_icn_mail@3x.40d013a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/mo_icn_mail@3x.png
// module id = 0P/A
// module chunks = 10